"use client";

import { useState, type FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LANDING_PRODUCTS, LandingProductPicker, type LandingProductSlug } from "./landing-product-picker";
import { LANDING_FIELD_BAR_CLASSES } from "./landing-field-bar";

function sellListingHref(product: LandingProductSlug, quantity: string) {
  const params = new URLSearchParams({ type: "sell", product });
  if (Number(quantity) > 0) params.set("qty", String(Math.round(Number(quantity))));
  return `/request-quote?${params.toString()}`;
}

function SellBar({ quantity, onQuantity }: { quantity: string; onQuantity: (value: string) => void }) {
  return (
    <div className={LANDING_FIELD_BAR_CLASSES}>
      <Input
        variant="ghost"
        inputMode="numeric"
        aria-label="How many do you have"
        placeholder="How many?"
        value={quantity}
        onChange={(event) => onQuantity(event.target.value.replace(/\D/g, ""))}
        className="flex-1"
      />
      <Button type="submit" variant="primary">
        Start listing
      </Button>
    </div>
  );
}

export function LandingSellStarter() {
  const [product, setProduct] = useState<LandingProductSlug>(LANDING_PRODUCTS[0].slug);
  const [quantity, setQuantity] = useState("");
  const submit = (event: FormEvent) => {
    event.preventDefault();
    window.location.assign(sellListingHref(product, quantity));
  };
  return (
    <form onSubmit={submit} aria-label="Start a listing" className="flex flex-col gap-4">
      <LandingProductPicker value={product} onChange={setProduct} className="sm:grid-cols-6" />
      <SellBar quantity={quantity} onQuantity={setQuantity} />
    </form>
  );
}
